/* Lattice&Life Animations */
(function() {
	/* Hero parallax */
	var heroBg = document.getElementById('llHeroBg');
	if (heroBg) {
		var tk = false;
		window.addEventListener('scroll', function() {
			if (!tk) {
				requestAnimationFrame(function() {
					var y = window.scrollY;
					if (y < 1200) {
						heroBg.style.transform = 'translateY(' + (y * 0.3) + 'px) scale(' + (1 + y * 0.00015) + ')';
					}
					tk = false;
				});
				tk = true;
			}
		}, { passive: true });
	}

	/* Scroll reveal with IntersectionObserver */
	var obs = new IntersectionObserver(function(entries) {
		entries.forEach(function(e) {
			if (e.isIntersecting) {
				e.target.classList.add('vis');
				if (e.target.dataset.count !== undefined) {
					animateCount(e.target);
				}
			}
		});
	}, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

	document.querySelectorAll('.ll-rv,.ll-rv-l,.ll-rv-r,.ll-rv-s,.ll-hl-stat').forEach(function(el) {
		obs.observe(el);
	});

	/* Counter animation */
	function animateCount(el) {
		var n = el.querySelector('.ll-hl-stat-num');
		if (!n || n.dataset.done) return;
		n.dataset.done = '1';
		var target = parseFloat(el.dataset.count);
		var suffix = el.dataset.suffix || '';
		var dec = parseInt(el.dataset.decimal || '0');
		var dur = 2400;
		var t0 = performance.now();

		function step(now) {
			var p = Math.min((now - t0) / dur, 1);
			var ease = 1 - Math.pow(1 - p, 3);
			var v = target * ease;
			n.textContent = dec > 0 ? v.toFixed(dec) + suffix : Math.round(v).toLocaleString() + suffix;
			if (p < 1) requestAnimationFrame(step);
		}
		requestAnimationFrame(step);
	}
})();

/* Price: 円 を小さく */
(function() {
	function formatYen(el) {
		if (!el || el.querySelector('.ll-price-yen')) return;
		var html = el.innerHTML;
		if (!html.includes('円')) return;
		el.innerHTML = html.replace(/円/, '<span class="ll-price-yen">円</span>');
	}
	function runAll() {
		document.querySelectorAll('.price-item, .llpicta-price').forEach(formatYen);
	}
	runAll();
	var obs = new MutationObserver(function() { runAll(); });
	document.querySelectorAll('.price').forEach(function(c) {
		obs.observe(c, { childList: true, subtree: true });
	});
})();

/* Mega menu: position below header dynamically (accounts for announce bar) */
(function() {
	function updateMegaTop() {
		var hw = document.querySelector('.header-wrapper');
		if (!hw) return;
		var top = hw.getBoundingClientRect().bottom + 'px';
		document.querySelectorAll('.ll-mega-menu, .ll-mega-backdrop').forEach(function(el) {
			el.style.top = top;
		});
	}
	updateMegaTop();
	window.addEventListener('scroll', updateMegaTop, { passive: true });
	window.addEventListener('resize', updateMegaTop);
})();

/* Product page — FAQ accordion */
document.addEventListener('click', function(e) {
	var q = e.target.closest('.llpfaq-q');
	if (q) q.parentElement.classList.toggle('open');
});
